<div class="no-chatbot-area" *ngIf="showAuthError$ | async">
  <img src="assets/img/not-found.svg" alt="Page Not Found" width="250px">
  <p style="font-size: 24px;">This page is not available. {{this.errorCode4Chars ? '(' + this.errorCode4Chars + ')' : ''}}</p>
</div>

<div class="chatbot-shell" *ngIf="!(isConversationalAgent$ | async) && !(showAuthError$ | async)">
  <div class="chatbot-area chatbot-area--enter"
    [ngClass]="{
      'screen-two': messages.length > 0,
      'chatbot-area-non-prod-ppe': isShowAdminUIControls,
      'chatbot-area--android': isAndroidPlatform
    }"
    *ngIf="messages$ | async as messages" #chatContent>
    <div class="chatbot-area-wrapper">

        <header class="chat-header"></header>

        <div class="landing-screen"
          [class.landing-screen--visible]="landingAnimationsReady$ | async"
          *ngIf="messages.length === 0 && (showLandingScreen$ | async)">
          <div class="landing-screen__main">
            <div *ngIf="isShowAdminUIControls" style="background-color: #ffff00;color: #000;position: absolute;width: 100%;top: 0;left: 0;z-index: 3;">
              CIF: {{this.cif}}
              <b>Browser:</b> {{this.deviceService?.browser}}
              <b>OS:</b> {{this.deviceService?.os}}
              <b>Device:</b> {{this.deviceService?.device}}
              <b>Device Type:</b> {{this.deviceService?.deviceType}}
              | {{streamBytes$|async}}
            </div>

            <h1 class="landing-greeting">
              <span class="landing-greeting__name">Hi {{ greetingName }},</span>
              <span class="landing-greeting__prompt">How can I help you?</span>
            </h1>

            <div class="info-message" *ngIf="!(isChatbotAvailable$|async)">
              The <strong>AI Chatbot KB</strong> is available only on supported devices.
            </div>
          </div>

          <div class="landing-screen__questions" *ngIf="(isChatbotAvailable$|async)">
            <div class="common-question-area">
              <p class="common-question-title">Common Questions{{ isAdmin ? ' (Mic: ' + (privInfo|async) + ')' : '' }}</p>
              <div class="common-question-wrapper">
                <a *ngFor="let question of commonQuestions" class="common-question"
                  (click)="sendCommonQuestion(question)">
                  <span>{{ question }}</span>
                </a>
              </div>
            </div>
            <div *ngIf="isAppAdmin" class="landing-screen__version">
              <span>v202505270800</span>
            </div>
          </div>
        </div>

        <ng-container *ngIf="messages.length === 0 && (showLandingScreen$ | async) && (isChatbotAvailable$|async)">
          <ng-container *ngTemplateOutlet="chatInputDock; context: { $implicit: tmp__ui_user_input_placehoder_text || final__ui_user_input_placehoder_text }"></ng-container>
        </ng-container>

        <!-- Screen After Message -->
        <div class="message-area message-area--enter" *ngIf="messages.length > 0 || isTyping" #messageArea>
          <div class="message-blk">
            <p class="message-blk-title" *ngIf="isAdmin"><span>(Mic: {{ privInfo|async }})</span></p>

            <div class="message-blk-wrapper">
              <div *ngFor="let msg of messages$ | async; let i = index; let last = last" class="message"
                [ngClass]="msg.sender == 'user'?'single-message user-message':'single-message ai-message'">
                <span class="profile-icon profile-icon--bot" *ngIf="msg.sender == 'bot' && msg.text">
                  <img src="assets/img/ai-chat/bot-avatar.svg" width="33.333" height="20" alt="" />
                </span>
                <div class="message-desc" *ngIf="msg.text">
                  <div class="message-text" [id]="'message-text-' + msg.id" [innerHTML]="msg.text"></div>
                  <p *ngIf="msg?.source && isAdmin" class="message-admin-meta">Source(s): {{msg.source}}</p>
                  <p *ngIf="msg?.elapsedTime && isAdmin" class="message-admin-meta">Elapsed Time: {{msg.elapsedTime}}</p>

                  <div echarts *ngIf="msg.sender == 'bot' && getEChartOptionsByResponseId(msg.id)"
                    [ngClass]="getEChartOptionsByResponseId(msg.id) ? '' : 'chart-hidden'"
                    [id]="'message-chart-' + msg.id"
                    [initOpts]="getEChartInitOptionsByResponseId(msg.id)"
                    [options]="getEChartOptionsByResponseId(msg.id)"
                    class="chart-container"></div>

                  <!-- bot message return -->
                  <button type="button" class="stop-btn stopButtonPlay" (click)="stopAudio(null, 'stop_bot_speaking')"
                    *ngIf="last && msg.sender == 'bot' && (isAudioPlaybackStarted$|async) && (isAudioTTOSPlaying$|async)">
                    <img class="stop-img" src="assets/img/stop.svg" alt="stop-icon">
                  </button>
                </div>
                <span class="profile-icon profile-icon--user" *ngIf="msg.sender == 'user'">
                  <img src="assets/img/ai-chat/user-avatar.svg" width="20" height="20" alt="" />
                </span>
              </div>
            </div>

            <div *ngIf="isTyping" class="typing-indicator">
              <span></span><span></span><span></span>
            </div>
          </div>
        </div>

        <div class="contextual-suggestions" *ngIf="messages.length > 0 && !isTyping && contextualSuggestions.length > 0">
          <button
            type="button"
            class="contextual-suggestion-chip"
            *ngFor="let suggestion of contextualSuggestions"
            (click)="sendContextualSuggestion(suggestion)">
            <span>{{ suggestion }}</span>
            <img src="assets/img/ai-chat/chip-arrow.svg" width="18.6885" height="20" alt="" />
          </button>
        </div>

        <ng-container *ngIf="messages.length > 0 || isTyping">
          <ng-container *ngTemplateOutlet="chatInputDock; context: { $implicit: tmp__ui_user_input_placehoder_text !== final__ui_user_input_placehoder_text ? tmp__ui_user_input_placehoder_text : conversationInputPlaceholder }"></ng-container>
        </ng-container>

    </div>
  </div>
</div>

<ng-template #chatInputDock let-placeholder>
  <div class="chat-input-dock">
    <div class="message-box">
      <div class="message-trash" [ngStyle]="{'display' : (((isSpeechListening$|async) && (userInput$|async).length) || totalUserInput.length) || (isDeleteUserInputOptionAvailable$|async) ? 'inline-flex' : 'none'}">
        <button type="button" class="trash-btn" (click)="stopAudio($event, 'bin')"><img src="assets/img/bin.svg" alt="remove"></button>
      </div>
      <div class="message-input__wave" [ngStyle]="{'display' : (isSpeechListening$|async) ? 'flex' : 'none'}">
        <svg id="audio_wave" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 38.05">
          <title>Audio Wave</title>
          <path id="audio_wave_line_1" data-name="Line 1" d="M0.91,15L0.78,15A1,1,0,0,0,0,16v6a1,1,0,1,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H0.91Z"/>
          <path id="audio_wave_line_2" data-name="Line 2" d="M6.91,9L6.78,9A1,1,0,0,0,6,10V28a1,1,0,1,0,2,0s0,0,0,0V10A1,1,0,0,0,7,9H6.91Z"/>
          <path id="audio_wave_line_3" data-name="Line 3" d="M12.91,0L12.78,0A1,1,0,0,0,12,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H12.91Z"/>
          <path id="audio_wave_line_4" data-name="Line 4" d="M18.91,10l-0.12,0A1,1,0,0,0,18,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H18.91Z"/>
          <path id="audio_wave_line_5" data-name="Line 5" d="M24.91,15l-0.12,0A1,1,0,0,0,24,16v6a1,1,0,0,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H24.91Z"/>
          <path id="audio_wave_line_6" data-name="Line 6" d="M30.91,10l-0.12,0A1,1,0,0,0,30,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H30.91Z"/>
          <path id="audio_wave_line_7" data-name="Line 7" d="M36.91,0L36.78,0A1,1,0,0,0,36,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H36.91Z"/>
          <path id="audio_wave_line_8" data-name="Line 8" d="M42.91,9L42.78,9A1,1,0,0,0,42,10V28a1,1,0,1,0,2,0s0,0,0,0V10a1,1,0,0,0-1-1H42.91Z"/>
          <path id="audio_wave_line_9" data-name="Line 9" d="M48.91,15l-0.12,0A1,1,0,0,0,48,16v6a1,1,0,1,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H48.91Z"/>
        </svg>
      </div>
      <div class="message-input">
        <textarea #mainTextInput
          [(ngModel)]="userInputNgModel"
          [placeholder]="placeholder"
          (keydown)="handleKeydownUserInput($event)"
          (focus)="onChatInputFocus()"
          (input)="adjustMainInputHeight()"
          rows="1"
          autocomplete="off"
          autocapitalize="off"
          autocorrect="off"
          spellcheck="false"
          enterkeyhint="send"
          class="auto-height-textarea"
          [class.auto-height-textarea--listening]="(isSpeechListening$|async)"
        ></textarea>
      </div>
      <div class="message-box-action">
        <button type="button" class="stop-btn" (click)="stopAudio($event, 'mic')" *ngIf="(isSpeechListening$|async)">
          <img class="stop-img" src="assets/img/stop.svg" alt="stop-icon" width="16" height="16">
        </button>

        <button type="button" class="voice-btn"
          *ngIf="!(isSpeechListening$|async)"
          [disabled]="isButtonDisabled$ | async"
          [ariaDisabled]="isButtonDisabled$ | async"
          (click)="((isSpeechListening$.value) ? null : startDeepgramWSStreaming(false))"
          aria-label="Dictate">
          <span class="loading" *ngIf="(isWaitingForMicAudioOrSocket$|async)"></span>
          <img *ngIf="!(isWaitingForMicAudioOrSocket$|async)" src="assets/img/ai-chat/input-mic.svg" width="16" height="16" alt="" />
        </button>
      </div>
    </div>

    <button type="button" class="chat-round-btn"
      *ngIf="userInputNgModel.trim().length === 0 && !(isSpeechListening$|async)"
      [disabled]="isButtonDisabled$ | async"
      [ariaDisabled]="isButtonDisabled$ | async"
      (click)="((isSpeechListening$.value) ? null : navigateToAgent())"
      aria-label="Start voice agent">
      <img src="assets/img/ai-chat/voice-wave.svg" width="17" height="16" alt="" />
    </button>

    <button type="button" class="chat-round-btn"
      *ngIf="userInputNgModel.trim().length > 0 || (isSpeechListening$|async)"
      [class.chat-round-btn--pending]="!((isSendEligible$|async) || (isSendReady$|async))"
      (click)="sendMessageGetStream($event)"
      aria-label="Send">
      <img src="assets/img/ai-chat/send-arrow.svg" width="17.4828" height="17.4828" alt="" />
    </button>
  </div>
</ng-template>

<!-- Conversational Agent Section -->
<div *ngIf="(isConversationalAgent$ | async)">
  <app-chatbot-agent
  [cif]="cif"
  [currentSessionId]="currentSessionId"
  [currentUserName]="currentUserName"
  (cancelChatbot)="onCancelChatbot($event)"></app-chatbot-agent>
</div>
